<template lang="pug">
v-row(no-gutters)
  v-col.pa-10(cols="3" xl="2")
    .sticky.top-24.white
      .text-md.font-semibold.neutral500--text.px-4.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/settings/business-details')") {{ $t('business_details') }}
      .text-md.font-semibold.neutral500--text.px-4.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/settings/tax')") {{ $t('tax_settings') }}
      .text-md.font-semibold.neutral200.px-4.py-2.round-md.mb-2 e-Invoice settings

  v-col.neutral200(cols="9" xl="10")
    v-form(ref="form")
      v-container.pa-8(fluid style="width:85%")
        .d-flex.align-center.mb-6
          v-btn.mr-4(icon small)
            v-icon(color="primary" @click="back") mdi-arrow-left
          .text-2xl.font-semibold e-Invoice Settings

        v-card.round-xl.pa-6.mb-4(outlined)

          div.text-sm.font-medium.neutral700--text Tax Identification Number (TIN)
          v-text-field.round-xl.mt-2(v-model="tin" placeholder="Enter Tax Identification Number (TIN)" dense outlined height="48" :loading="isFetching" :rules="rules.not_empty" hide-details="auto")
          div.text-sm.font-medium.neutral700--text.mt-3 Malaysia Standard Industrial Classification (MSIC)
          y-select.mt-2(v-model="msic" :items="msicList" item-text="name" item-value="code" placeholder="Select MSIC" :loading="isFetching" :rules="rules.not_empty_select" attach)
          div.text-sm.font-medium.neutral700--text.mt-3 Registration Type
          y-select.mt-2(v-model="regtype" :items="regList" item-text="name" item-value="code" placeholder="Select registration type" :loading="isFetching" :rules="rules.not_empty_select" attach)
          div.text-sm.font-medium.neutral700--text.mt-3 Registration Number
          v-text-field.round-xl.mt-2(v-model="regnum" placeholder="Enter Registration Number" dense outlined height="48" :loading="isFetching" hide-details="auto")
          div.text-sm.font-medium.neutral700--text.mt-3 Company address
          .company-address.mt-3
            div.text-xs.font-medium.neutral500--text {{$t('address_1.label')}}
            v-text-field.round-xl.mt-1(v-model="address.address_1" :placeholder="$t('address_1.placeholder')" dense outlined height="48" :loading="isFetching" :rules="rules.not_empty" hide-details="auto")
            div.text-xs.font-medium.neutral500--text.mt-3 {{$t('address_2.label')}}
            v-text-field.round-xl.mt-1(v-model="address.address_2" :placeholder="$t('address_2.placeholder')" dense outlined height="48" :loading="isFetching" :rules="rules.not_empty" hide-details="auto")
            div.text-xs.font-medium.neutral500--text.mt-3 {{$t('postcode.label')}}
            v-text-field.round-xl.mt-1(v-model="address.postcode" :placeholder="$t('postcode.placeholder')" dense outlined height="48" :loading="isFetching || isFetchingAddress" :rules="rules.not_empty" @keyup="fetchPostcodes(address.postcode)" hide-details="auto")
            div.text-xs.font-medium.neutral500--text.mt-3 {{$t('city.label')}}
            v-text-field.round-xl.mt-1(v-model="address.city" :placeholder="$t('city.placeholder')" dense outlined height="48" :loading="isFetching || isFetchingAddress" :rules="rules.not_empty" hide-details="auto")
            div.text-xs.font-medium.neutral500--text.mt-3 {{$t('state.label')}}
            v-text-field.round-xl.mt-1(v-model="address.state" :placeholder="$t('state.placeholder')" dense outlined height="48" :loading="isFetching || isFetchingAddress" :rules="rules.not_empty" hide-details="auto")
            div.text-xs.font-medium.neutral500--text.mt-3 {{$t('country.label')}}
            v-text-field.round-xl.mt-1(v-model="address.country" :placeholder="$t('country.placeholder')" dense outlined height="48" :loading="isFetching || isFetchingAddress" :rules="rules.not_empty" hide-details="auto")

    v-footer.white(app inset padless)
      .d-flex.flex-column.grow
        v-divider
        .d-flex.justify-end.align-center.py-4.px-8
          y-button(label="Cancel" size="sm" color="primary" underline @click="back" :disabled="isLoading")
          y-button.ml-2(label="Save" size="sm" color="primary" @click="save" :loading="isLoading")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EInvoiceSettings',
  data () {
    return {
      isLoading: false,
      isFetching: false,
      isFetchingAddress: false,
      tin: null,
      regnum: null,
      msic: '86201',
      regtype: 'brn',
      address: {},
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        not_empty_select: [v => !!v || 'This field is required']
      },
      regList: [
        {
          code: "brn",
          name: "Company Registration Number (BRN)",
        },
        {
          code: "nric",
          name: "NRIC",
        },
        {
          code: "passport",
          name: "Passport",
        },
        {
          code: "army",
          name: "No Tentera / Army",
        },
      ],
      msicList: [
        {
          code: "86101",
          name: "Hospital activities",
        },
        {
          code: "86102",
          name: "Maternity home services (outside hospital)",
        },
        {
          code: "86201",
          name: "General medical services",
        },
        {
          code: "86202",
          name: "Specialized medical services",
        },
        {
          code: "86203",
          name: "Dental services",
        },
        {
          code: "86901",
          name: "Dialysis Centres",
        },
        {
          code: "86903",
          name: "Physiotherapy and occupational therapy service",
        },
        {
          code: "86904",
          name: "Acupuncture services",
        },
        {
          code: "86905",
          name: "Herbalist and homeopathy services",
        },
        {
          code: "86909",
          name: "Other human health services n.e.c.",
        },
        {
          code: "87101",
          name: "Homes for the elderly with nursing care",
        },
        {
          code: "87102",
          name: "Nursing homes",
        },
        {
          code: "87103",
          name: "Palliative or hospices",
        },
        {
          code: "87201",
          name: "Drug rehabilitation centres",
        },
        {
          code: "88901",
          name: "Counselling service",
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    accountDetailInserted () {
      return !!this.accountDetail.bank || !!this.accountDetail.accountNumber || !!this.accountDetail.accountHolderName
    }
  },
  mounted () {
    this.address = this.company.address || {}
    this.fetchMyinvois()
  },
  methods: {
    ...mapActions(['showMessage', 'updateCompany']),
    setData (data) {
      this.tin = data.tin
      this.regnum = data.registration_number
      this.regtype = data.registration_type
      this.msic = data.msic_code
      this.address = {
        address_1: data.address.address_1,
        address_2: data.address.address_2,
        postcode: data.address.postcode,
        city: data.address.city,
        state: data.address.state,
        country: data.address.country,
      }
    },
    fetchMyinvois () {
      this.isFetching = true
      this.$axios.get(`/companies/${this.company.slug}/myinvois`)
        .then(resp => {
          this.setData(resp.data)
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchPostcodes (val) {
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      this.isFetchingAddress = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.address.postcode}`)
        .then(response => {
          const addresses = response.data
          if (addresses.length > 0 && addresses[0].postcode) {
            this.$set(this.address, 'city', addresses[0].city)
            this.$set(this.address, 'state', addresses[0].state)
            this.$set(this.address, 'country', addresses[0].country)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingAddress = false
        })
    },
    save () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let payload = {
        tin: this.tin,
        registration_number: this.regnum,
        registration_type: this.regtype,
        msic_code: this.msic,
        msic_name: this.msicList.find(msic => msic.code === this.msic).name,
        address: this.address
      }
      this.$axios.post(`/companies/${this.company.slug}/myinvois`, payload)
        .then(resp => {
          this.showMessage(['success', 'e-Invoice settings saved successfully'])
          this.fetchCompany()
          this.setData(resp.data)
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.length > 0) {
            message = err.response.data[0]
          } else if (err.response.data) {
            let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
            if (data) { message = data  }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchCompany () {
      this.$axios.get(`/companies/${this.company.id}`)
        .then(resp => {
          this.updateCompany(resp.data)
        })
        .catch(() => {})
    },
    back () {
      this.$router.push('/admin/clinic/settings')
    },
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    }
  },
  "id": {
    "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    }
  }
}
</i18n>